export class OrphyEditor extends kendo.ui.Editor {
    constructor(element, options) {
        super(element, options);
        this.changeValue = (value) => {
            if ($(this.element).hasClass("inheritedSetting")) {
                $(this.element).removeClass("inheritedSetting");
            }
            this.value(value);
            this.trigger("change");
        };
        this.onFocus = () => {
            if ($(this.element).hasClass("inheritedSetting")) {
                $(this.element).removeClass("inheritedSetting");
                this.value("");
            }
        };
        this.onBlur = () => {
            let value = this.value();
            value = value.replace(/<\/?[^>]+(>|$)/g, ""); // Strip html tags
            if (!value) {
                $(this.element).addClass("inheritedSetting");
                this.value(this.placeholderText);
            }
        };
        this.placeholderText = element.getAttribute("placeholder");
        if (this.placeholderText) {
            $(element).on("focus", this.onFocus);
            $(element).on("blur", this.onBlur);
            this.onBlur();
        }
    }
    value(value) {
        if ($(this.element).hasClass("inheritedSetting")) {
            // Return empty string because placeholder value is being displayed
            super.value(value);
            return "";
        }
        return super.value(value);
    }
}
// Create an alias of the prototype (required by kendo.ui.plugin)
OrphyEditor.fn = OrphyEditor.prototype;
// Deep clone the widget default options
OrphyEditor.fn.options = $.extend(true, {}, kendo.ui.Editor.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
OrphyEditor.fn.options.name = "OrphyEditor";
// Create a jQuery plugin.
kendo.ui.plugin(OrphyEditor);
